
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import {fetch,promptMessage } from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import {urlConfig} from '@/api/urlConfig';
export default {
data(){
return {
personInfoId:''
}
},
methods: {
getUserId(){
fetch('get',urlConfig.GetSfzh + '?openid='+this.$route.query.openid).then(response => {
this.getPersonInfoId(response.sfzh);

}).catch(error => {

})
},
getPersonInfoId(sfzh){
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.personInfoId = response.personInfoId;
this.getData();

}).catch(error => {
})
},

getData(){

fetch('post',urlConfig.queryPatientIsVip+ '?personInfoId='+this.personInfoId).then(response => {
console.log('response='+response);

if(response=='1'){
window.location.href = "https://weixin.keruyun.com/orderall/dishMenu4Quik?shopId=810661372&tableId=b8fcfa4012bb4332bc69b77b82dbbfa0&goShopDetailLogic=true&type=TS";

}else{
promptMessage('此服务仅对VIP客户开放！' );
this.$store.commit('updateLoadingStatus',{isLoading:false});

}

}).catch(error => {

})
},

},
mounted(){
getken(this.getUserId);
this.$store.commit('updateLoadingStatus',{isLoading:true})
}
}



// WEBPACK FOOTER //
// ./src/project/orderFoodProject/orderFood.vue